<template>
  <el-dialog
    :title="isUpdate ? '编辑国家' : '添加国家'"
    :visible="visible"
    width="600px"
    :destroy-on-close="true"
    :lock-scroll="false"
    custom-class="ele-dialog-form"
    append-to-body
    @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="国家名称:" prop="name">
        <el-input v-model="form.name" clearable placeholder="请输入" maxlength="100" />
      </el-form-item>
      <el-form-item label="国家编码:" prop="code">
        <el-input v-model="form.code" clearable placeholder="请输入" maxlength="10" />
      </el-form-item>
      <el-form-item label="货币编码:" prop="currency">
        <el-select
          v-model="form.currency"
          clearable
          filterable
          placeholder="请选择"
          class="ele-fluid"
          :loading="cnyLoading">
          <el-option
            v-for="item in cnyList"
            :key="item.id"
            :label="formatCnyLabel(item)"
            :value="item.code" />
        </el-select>
      </el-form-item>
      <el-row :gutter="15">
        <el-col :sm="12">
          <el-form-item label="排序:" prop="sort">
            <el-input-number v-model="form.sort" :min="0" :max="9999" controls-position="right" class="ele-fluid" />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="状态:" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio v-for="item in statusOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注:" prop="note">
        <el-input v-model="form.note" type="textarea" :rows="2" resize="none" placeholder="请输入" maxlength="255" show-word-limit />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { loadDictOptions } from '@/utils/dict';

const defaultForm = () => ({
  name: '',
  code: '',
  currency: '',
  status: 1,
  sort: 0,
  note: ''
});

export default {
  name: 'CountryRegionEdit',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      form: defaultForm(),
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        code: [{ required: true, message: '请输入', trigger: 'blur' }],
        currency: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        status: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      loading: false,
      isUpdate: false,
      cnyList: [],
      cnyLoading: false,
      statusOptions: []
    };
  },
  mounted() {
    loadDictOptions('switch_status', { numberValue: true })
      .then((list) => { this.statusOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
        this.queryCny();
      }
    },
    data() {
      if (this.visible) {
        this.initForm();
      }
    }
  },
  methods: {
    formatCnyLabel(item) {
      if (item.name) {
        return `${item.code} - ${item.name}`;
      }
      return item.code;
    },
    queryCny() {
      if (this.cnyList.length) {
        return;
      }
      this.cnyLoading = true;
      this.$http.get('/FiatCurrency/getFiatCurrencyList').then((res) => {
        this.cnyLoading = false;
        if (res.data.code === 0) {
          this.cnyList = res.data.data || [];
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.cnyLoading = false;
        this.$message.error(e.message);
      });
    },
    initForm() {
      if (this.data && Object.keys(this.data).length) {
        this.form = Object.assign(defaultForm(), this.data);
        this.isUpdate = true;
      } else {
        this.form = defaultForm();
        this.isUpdate = false;
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.loading = true;
        this.$http.post('/CountryRegion/edit', this.form).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg || '保存成功');
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg || '保存失败');
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>
